import { datadogLogs } from '@datadog/browser-logs';

export function useLogger(logger = datadogLogs.logger) {
  return {
    info: (message, context = {}) => logger.info(message, context),
    warn: (message, context = {}) => logger.warn(message, context),
    error: (message, context = {}) => logger.error(message, context),
  };
}

function createWithLogs(level) {
  return function (fn, message, context = {}) {
    const log = useLogger();
    try {
      const result = fn();
      log[level](message, context);
      return result;
    } catch (error) {
      log.error(message, {
        ...context,
        error,
      });
      throw error;
    }
  };
}

export const withLogs = {
  info: createWithLogs('info'),
  warn: createWithLogs('warn'),
  error: createWithLogs('error'),
};
